<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form :model="queryParams" ref="queryForm" size="small" label-width="100px">
          <el-row :gutter="24" type="flex">
            <el-col :span="5">
              <el-form-item label="客户名称" prop="compNames">
                <el-input v-model="queryParams.compNames" placeholder="请输入客户名称" clearable @keyup.enter.native="handleQuery" />
                <CustomerDetails v-model="queryParams.compNames" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="使用单位" prop="USE_UNT_NAME">
                <el-input v-model="queryParams.USE_UNT_NAME" placeholder="请输入使用单位" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="小区名称" prop="houseName">
                <el-input v-model="queryParams.houseName" placeholder="请输入小区名称" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="识别码" prop="OIDNO">
                <el-input v-model="queryParams.OIDNO" placeholder="请输入识别码" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="产品编号" prop="FACTORY_COD">
                <el-input v-model="queryParams.FACTORY_COD" placeholder="请输入产品编号" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" type="flex">
            <el-col :span="5">
              <el-form-item label="到检年月" prop="inspectionMonthList">
                <el-date-picker v-model="queryParams.inspectionMonthList" type="months" placeholder="请选择到检年月" clearable value-format="yyyy-MM" style="width: 100%;" @change="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="上传状态" prop="ispinfoSubmitState">
                <el-select v-model="queryParams.ispinfoSubmitState" placeholder="请选择上传状态" clearable @change="handleQuery" style="width: 100%;" >
                  <el-option label="全部" :value="''" />
                  <el-option label="已上传" value="0" />
                  <el-option label="未上传" value="1" />
                  <el-option label="上传失败" value="2" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="备注" prop="ispinfoSubmitRemark">
                <el-select v-model="queryParams.ispinfoSubmitRemark" placeholder="请输入或选择备注" filterable allow-create default-first-option clearable @change="handleQuery" style="width: 100%;" >
                  <el-option label="没有符合性" value="没有符合性" />
                  <el-option label="维保合同为空" value="维保合同为空" />
                  <el-option label="不合格，报送成功" value="不合格，报送成功" />
                  <el-option label="检验检测机构为空" value="检验检测机构为空" />
                  <el-option label="其他" value="其他" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" type="flex">

          </el-row>
          <div style="text-align: center; margin-bottom: 10px;">
            <!-- <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">查询</el-button> -->
            <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleQuery="handleQuery" @handleUpload="handleUpload" @AddRemarks="AddRemarks" @batchDataUploadBack="batchDataUploadBack" />
            <!-- <el-button icon="el-icon-refresh" size="small" @click="handleReset">重置</el-button> -->
          </div>
          <!-- 表格 -->
          <el-table :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }" v-loading="loading"
                    element-loading-text="正在查询数据..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" row-key="id" @selection-change="handleSelectionChange"
                    height="500">
            <el-table-column type="selection" width="55" fixed="left" align="left"></el-table-column>
            <el-table-column type="index" label="序号" width="60" align="left"  :index="indexMethod"></el-table-column>
            <el-table-column label="检测日期" align="left" prop="testDate" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="检测人" align="left" prop="employeeName" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="签发日期" align="left" prop="approveDate" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column label="视频是否上传" align="left" prop="videoStatus" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ getVideoUploadStatusText(scope.row.videoStatus) }}
              </template>
            </el-table-column>
            <el-table-column label="视频大小" align="left" prop="videoSize" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.videoSize">{{ (scope.row.videoSize / 1024 / 1024 ).toFixed(2) }} MB</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="到检年月" align="left" prop="inspectionMonth" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="识别码" align="left" prop="OIDNO" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="状态" align="left" prop="status" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">
                <span :class="['status-text', `status-${scope.row.ispinfoSubmitState}`]">
                  {{ getIspSubmitStateText(scope.row.ispinfoSubmitState) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="设备所在县区" align="left" prop="EQP_AREA_NAME" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="监管上传日期" align="left" prop="ispinfoSubmitTime" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="失败原因" align="left" prop="ispinfoSubmitMsg" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="备注" align="left" prop="ispinfoSubmitRemark" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column label="使用单位" align="left" prop="USE_UNT_NAME" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column label="小区名称" align="left" prop="houseName" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="业务联系人及电话" align="left" min-width="150" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.contactPerson }} / {{ scope.row.contactTel }}
              </template>
            </el-table-column>
            <el-table-column label="现场联系人及电话" align="left" min-width="150" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.siteContact }} / {{ scope.row.siteContactTel }}
              </template>
            </el-table-column>
            <el-table-column label="客户名称" align="left" prop="compName" min-width="160" show-overflow-tooltip ></el-table-column>
            <el-table-column label="委托编号" align="left" prop="entrustNum" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column label="产品编号" align="left" prop="FACTORY_COD" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="使用地址" align="left" prop="EQP_USE_ADDR" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column label="层数/高度/长度" align="left" prop="ELEFLOORNUMBER" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="审核日期" align="left" prop="auditDate" min-width="160" show-overflow-tooltip></el-table-column>
            <!-- <el-table-column label="报告日期" align="left" prop="reportDate" min-width="120" show-overflow-tooltip></el-table-column> -->
            <el-table-column label="操作" align="left" width="520" fixed="right">
              <template slot-scope="scope">
                <!-- 旧按钮已停用：handleDownloadDeclaration、handleDetail、ModifyRemarks -->
                <PermissionMethodRow :url="url" :id="'rowtoolbar'" @handleEquipmentInfo="handleEquipmentInfo(scope.row)" @handleMemoDetail="handleMemoDetail(scope.row)" @handleRectificationDetail="handleRectificationDetail(scope.row)" @handlePDF="handlePDF(scope.row)" @handleViewSingle="handleViewSingle(scope.row)" />
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.currPage" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="queryParams.pageSize"
                         layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-form>
      </el-col>
    </el-row>

    <!-- 上传对话框 -->
    <el-dialog title="上传数据" :visible.sync="uploadDialogVisible" width="600px" :before-close="closeUploadDialog">
      <el-form :model="uploadForm" ref="uploadForm" label-width="120px" :rules="uploadRules">
        <el-form-item label="客户名称">
          <el-input v-model="uploadForm.compName" disabled />
        </el-form-item>
        <el-form-item label="识别码">
          <el-input v-model="uploadForm.OIDNO" disabled />
        </el-form-item>
        <el-form-item label="上传文件" prop="file">
          <el-upload class="upload-demo" drag action="#" :auto-upload="false" :on-change="handleFileChange" :file-list="fileList" :limit="1" accept=".mp4,.avi,.mov,.pdf,.doc,.docx">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">支持视频文件（mp4/avi/mov）或文档文件（pdf/doc/docx），且不超过 100MB</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeUploadDialog">取 消</el-button>
        <el-button type="primary" @click="confirmUpload" :loading="uploadLoading">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 详情对话框 -->
    <el-dialog title="数据详情" :visible.sync="detailDialogVisible" width="800px" :before-close="closeDetailDialog">
      <!-- 基础信息部分 -->
      <div class="detail-section">
        <div class="section-title">基础信息</div>
        <div class="info-content">
          <div class="info-row">
            <span class="info-label">委托编码：</span>
            <span class="info-value">{{ detailData.entrustNum }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">客户名称：</span>
            <span class="info-value">{{ detailData.compName }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">使用单位：</span>
            <span class="info-value">{{ detailData.USE_UNT_NAME }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">小区名称：</span>
            <span class="info-value">{{ detailData.houseName }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">业务联系人：</span>
            <span class="info-value">{{ detailData.contactPerson }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">业务联系人电话：</span>
            <span class="info-value">{{ detailData.contactTel }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">现场联系人：</span>
            <span class="info-value">{{ detailData.siteContact }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">现场联系人电话：</span>
            <span class="info-value">{{ detailData.siteContactTel }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">识别码：</span>
            <span class="info-value">{{ detailData.OIDNO }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">视频大小：</span>
            <span class="info-value">{{ detailData.videoSize }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">产品编号：</span>
            <span class="info-value">{{ detailData.FACTORY_COD }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">使用地址：</span>
            <span class="info-value">{{ detailData.EQP_USE_ADDR }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">设备所在县区：</span>
            <span class="info-value">{{ detailData.EQP_AREA_NAME }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">层数：</span>
            <span class="info-value">{{ detailData.ELEFLOORNUMBER }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">到检年月：</span>
            <span class="info-value">{{ detailData.inspectionMonth }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">检测日期：</span>
            <span class="info-value">{{ detailData.testDate }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">检测人：</span>
            <span class="info-value">{{ detailData.employeeName }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">报告日期：</span>
            <span class="info-value">{{ detailData.reportDate }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">状态：</span>
            <span class="info-value">
              <el-tag :type="detailData.ispinfoSubmitState === '0' ? 'success' : 'danger'" size="small">
                {{ getIspSubmitStateText(detailData.ispinfoSubmitState) }}
              </el-tag>
            </span>
          </div>
          <div class="info-row">
            <span class="info-label">失败原因：</span>
            <span class="info-value">{{ detailData.ispinfoSubmitMsg || '无' }}</span>
          </div>
        </div>
      </div>

      <!-- 文件预览部分 -->
      <div class="detail-section">
        <div class="section-title">文件预览</div>
        <div class="file-buttons">
          <el-button type="primary" icon="el-icon-document" :disabled="!detailData.memoFileUUID" @click="handlePreviewFile(detailData.memoFileUUID, '备忘录文件')">
            查看备忘录文件
          </el-button>
          <el-button type="primary" icon="el-icon-document" :disabled="!detailData.fileUUID" @click="handlePreviewFile(detailData.fileUUID, '符合性声明文件')">
            查看符合性声明文件
          </el-button>
          <el-button type="primary" icon="el-icon-document" :disabled="!detailData.reportPdf" @click="handlePreviewFile(detailData.reportPdf, '报告文件')">
            查看报告文件
          </el-button>
          <el-button type="primary" icon="el-icon-document" :disabled="!detailData.testPdf" @click="handlePreviewFile(detailData.testPdf, '原始记录文件')">
            查看原始记录文件
          </el-button>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDetailDialog">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 备注新增/修改对话框 -->
    <el-dialog :title="remarkDialogTitle" :visible.sync="remarkDialogVisible" width="600px" :before-close="closeRemarkDialog">
      <el-form :model="remarkForm" ref="remarkForm" label-width="120px" :rules="remarkRules">
        <el-form-item label="委托编号">
          <el-input type="textarea" :rows="2" v-model="remarkForm.entrustNumDisplay" disabled />
        </el-form-item>
        <el-form-item label="识别码">
          <el-input type="textarea" :rows="2" v-model="remarkForm.oidnoDisplay" disabled />
        </el-form-item>
        <el-form-item label="备注" prop="ispinfoSubmitRemark">
          <el-select v-model="remarkForm.ispinfoSubmitRemark" placeholder="请输入或选择备注" filterable allow-create default-first-option clearable style="width: 100%;">
            <el-option label="没有符合性" value="没有符合性" />
            <el-option label="维保合同为空" value="维保合同为空" />
            <el-option label="不合格，报送成功" value="不合格，报送成功" />
            <el-option label="检验检测机构为空" value="检验检测机构为空" />
            <el-option label="其他" value="其他" />
          </el-select>
        </el-form-item>
        <el-form-item label="操作人">
          <el-input v-model="remarkForm.remarkOperator" disabled />
        </el-form-item>
        <el-form-item :label="remarkDialogMode === 'add' ? '操作日期' : '修改日期'">
          <el-date-picker v-model="remarkForm.operationDate" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 100%;" disabled />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeRemarkDialog">取 消</el-button>
        <el-button type="primary" @click="handleRemarkConfirm">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 文件预览对话框 -->
    <el-dialog :title="previewTitle" :visible.sync="previewDialogVisible" width="80%" append-to-body :before-close="closePreviewDialog">
      <PdfImgViewer ref="pdfImgViewer" :fileName="currentFileUUID" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="closePreviewDialog">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 视频播放对话框 -->
    <el-dialog title="视频播放" :visible.sync="videoDialogVisible" width="60%" append-to-body :before-close="closeVideoDialog">
      <div class="video-container">
        <video v-if="currentVideoUrl" ref="videoPlayer" :src="currentVideoUrl" controls style="width: 100%; max-height: 70vh;">
          您的浏览器不支持视频播放
        </video>
        <div v-else class="no-video">
          <el-empty description="暂无视频文件"></el-empty>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeVideoDialog">关 闭</el-button>
      </span>
    </el-dialog>
    <EquipmentConfirmDialog ref="equipmentConfirmDialog" />
    <Rectification ref="rectificationDialog" />
  </div>
</template>

<script>
// TODO: 导入API方法
import { queryUploadDataList, uploadData, submitTestDataRemark, previewTestDataPdf, batchDataUploadBack } from '@/api/contract/contract';
import PdfImgViewer from '@/components/pdfview/PdfImgViewer.vue';
import EquipmentConfirmDialog from '../OriginalManagement/EquipmentConfirmDialog.vue';
import Rectification from '../rectificationItem/rectification.vue';

export default {
  name: 'DataUpload',
  components: {
    PdfImgViewer,
    EquipmentConfirmDialog,
    Rectification
  },
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  // 初始化页面状态、查询参数和各类弹窗表单数据
  data () {
    return {
      // 显示搜索条件
      showSearch: true,
      // 表格数据
      tableData: [],
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
        currPage: 1,
        pageSize: 200,
        compNames: undefined,
        USE_UNT_NAME: undefined,
        houseName: undefined,
        OIDNO: undefined,
        FACTORY_COD: undefined,
        inspectionMonthList: [],
        ispinfoSubmitState: '1',
        ispinfoSubmitRemark: undefined
      },
      // 上传对话框
      uploadDialogVisible: false,
      uploadForm: {
        id: undefined,
        compName: '',
        OIDNO: '',
        file: null
      },
      uploadRules: {
        file: [
          { required: true, message: '请选择要上传的文件', trigger: 'change' }
        ]
      },
      uploadLoading: false,
      fileList: [],
      // 详情对话框
      detailDialogVisible: false,
      detailData: {},
      // 文件预览对话框
      previewDialogVisible: false,
      currentFileUUID: '',
      previewTitle: '',
      // 视频播放对话框
      videoDialogVisible: false,
      currentVideoUrl: '',
      // 选中的行数据
      selectedRows: [],
      // SSE连接对象
      eventSource: null,
      // 备注弹窗
      remarkDialogVisible: false,
      remarkDialogTitle: '',
      remarkDialogMode: 'add', // add 或 edit
      remarkForm: {
        operType: '0',
        entrustNums: [],
        entrustNumDisplay: '',
        oidnoDisplay: '',
        ispinfoSubmitRemark: '',
        remarkOperator: '',
        operationDate: ''
      },
      remarkRules: {
        // ispinfoSubmitRemark: [
        //   { required: true, message: '请选择或输入备注', trigger: 'change' }
        // ]
      }
    };
  },
  // 页面创建后立即加载列表数据
  created () {
    this.getList();
  },
  methods: {
    // 计算序号（考虑分页）
    indexMethod (index) {
      return (this.queryParams.currPage - 1) * this.queryParams.pageSize + index + 1;
    },
        // 视频上传状态值转中文显示
    getVideoUploadStatusText (status) {
      const value = String(status);
      switch (value) {
        case '0':
          return '上传中';
        case '1':
          return '已完成';
        case '2':
          return '上传失败';
        case '3':
          return '文件合并中';
        case '4':
          return 'NAS同步中';
        case '5':
          return '未上传';
        default:
          return '未上传';
      }
    },
    // 获取状态文本
    getIspSubmitStateText (status) {
      switch (status) {
        case '-1':
          return '上传中...';
        case '0':
          return '已上传';
        case '1':
          return '未上传';
        case '2':
          return '上传失败';
        default:
          return '未知';
      }
    },
    // 查询列表
    getList () {
      this.loading = true;
      queryUploadDataList(this.queryParams).then(res => {
        if (res && res.retCode === 'ok' && res.additionalData) {
          const { records = [], current = this.queryParams.currPage, size = this.queryParams.pageSize, total = 0 } = res.additionalData || {};
          this.tableData = records;
          this.queryParams.currPage = current;
          this.queryParams.pageSize = size;
          this.total = total;
        } else {
          this.$message.error((res && res.retMsg) || '获取数据列表失败');
        }
        this.loading = false;
      }).catch(error => {
        console.error('获取数据列表失败:', error);
        this.loading = false;
        this.$message.error('获取数据列表失败');
      });
    },
    // 查询按钮
    handleQuery () {
      this.queryParams.currPage = 1;
      this.getList();
    },
    // 重置按钮
    handleReset () {
      this.queryParams = {
        currPage: 1,
        pageSize: 200,
        compNames: undefined,
        USE_UNT_NAME: undefined,
        houseName: undefined,
        OIDNO: undefined,
        FACTORY_COD: undefined,
        inspectionMonthList: [],
        ispinfoSubmitState: '1',
        ispinfoSubmitRemark: undefined
      };
      this.getList();
    },
    // 查看视频
    handleViewSingle (row) {
      const videoUrl = row.videoFileUrl || row.videoUrl || row.videoPath;
      if (!videoUrl) {
        this.$message.warning('该记录暂无视频文件');
        return;
      }
      this.currentVideoUrl = videoUrl;
      this.videoDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.videoPlayer) {
          this.$refs.videoPlayer.play().catch(error => {
            console.error('自动播放失败:', error);
          });
        }
      });
    },
    // 关闭视频播放对话框
    closeVideoDialog () {
      this.videoDialogVisible = false;
      this.$nextTick(() => {
        if (this.$refs.videoPlayer) {
          this.$refs.videoPlayer.pause();
          this.$refs.videoPlayer.currentTime = 0;
        }
        this.currentVideoUrl = '';
      });
    },
    // 上传按钮
    handleUpload () {
      // 检查是否选中数据
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要上传的数据');
        return;
      }

      // 用户确认
      this.$confirm('确定要对选中的数据进行上传吗？', '确认上传', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.performDataUpload(this.selectedRows);
      }).catch(() => {
        // 用户取消
      });
    },
    // 文件选择改变
    handleFileChange (file, fileList) {
      this.fileList = fileList;
      this.uploadForm.file = file.raw;
    },
    // 关闭上传对话框
    closeUploadDialog () {
      this.uploadDialogVisible = false;
      this.$refs.uploadForm.resetFields();
      this.fileList = [];
    },
    // 确认上传
    confirmUpload () {
      this.$refs.uploadForm.validate((valid) => {
        if (valid) {
          if (this.fileList.length === 0) {
            this.$message.warning('请选择要上传的文件');
            return;
          }

          this.uploadLoading = true;

          // TODO: 调用实际的API
          // const formData = new FormData();
          // formData.append('id', this.uploadForm.id);
          // formData.append('file', this.uploadForm.file);
          // uploadData(formData).then(res => {
          //   if (res && res.retCode === 'ok') {
          //     this.$message.success('上传成功');
          //     this.closeUploadDialog();
          //     this.getList();
          //   } else {
          //     this.$message.error((res && res.retMsg) || '上传失败');
          //   }
          //   this.uploadLoading = false;
          // }).catch(error => {
          //   console.error('上传失败:', error);
          //   this.$message.error('上传失败');
          //   this.uploadLoading = false;
          // });

          // 模拟上传
          setTimeout(() => {
            this.$message.success('上传成功');
            this.closeUploadDialog();
            this.getList();
            this.uploadLoading = false;
          }, 1000);
        }
      });
    },
    // 下载符合性申明（已停用）
    // handleDownloadDeclaration (row) {
    //   // 检查是否存在文件UUID
    //   if (!row.fileUUID) {
    //     this.$message.warning('该记录没有符合性申明文件');
    //     return;
    //   }
    //
    //   this.$message.info('正在下载符合性申明...');
    //
    //   try {
    //     // 构建下载URL（根据PdfImgViewer组件的逻辑，文件路径为 /api/pdf/文件名）
    //     const downloadUrl = `/api/pdf/${row.fileUUID}`;
    //
    //     // 创建隐藏的a标签进行下载
    //     const link = document.createElement('a');
    //     link.href = downloadUrl;
    //     link.download = `符合性申明_${row.OIDNO || 'unknown'}_${new Date().getTime()}.pdf`;
    //     link.style.display = 'none';
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    //
    //     this.$message.success('下载成功');
    //   } catch (error) {
    //     console.error('下载失败:', error);
    //     this.$message.error('下载失败，请重试');
    //   }
    // },
    // 详情按钮（已停用）
    // handleDetail (row) {
    //   this.detailData = { ...row };
    //   console.log(this.detailData);
    //
    //   this.detailDialogVisible = true;
    // },
    // 关闭详情对话框
    closeDetailDialog () {
      this.detailDialogVisible = false;
      this.detailData = {};
    },
    // 预览文件
    handlePreviewFile (fileUUID, title) {
      if (!fileUUID) {
        this.$message.warning('文件不存在');
        return;
      }
      this.currentFileUUID = fileUUID;
      this.previewTitle = title;
      this.previewDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.pdfImgViewer) {
          this.$refs.pdfImgViewer.init();
        }
      });
    },
    // 批量数据上传退回
    batchDataUploadBack () {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning('请先勾选需要退回的数据');
        return;
      }

      const entrustNums = [...new Set(this.selectedRows.map(item => item.entrustNum).filter(Boolean))];
      if (entrustNums.length === 0) {
        this.$message.warning('未获取到有效的委托编号');
        return;
      }

      this.$prompt('请输入退回备注', '确认批量退回', {
        confirmButtonText: '确定退回',
        cancelButtonText: '取消',
        inputValue: '',
        inputPlaceholder: '请输入退回原因',
        closeOnClickModal: false,
        inputPattern: /.*\S.*/,
        inputErrorMessage: '退回备注不能为空'
      }).then(({ value }) => {
        const payload = {
          entrustNums,
          backReason: value.trim()
        };
        batchDataUploadBack(payload).then(res => {
          if (res && res.retCode === 'ok') {
            this.$message.success('批量退回成功');
            this.getList();
            this.selectedRows = [];
          } else {
            this.$message.error((res && res.retMsg) || '批量退回失败');
          }
        }).catch(error => {
          console.error('批量退回失败:', error);
          this.$message.error('批量退回失败，请重试');
        });
      }).catch(() => {});
    },
    // 打开设备信息弹窗，查看当前委托单的设备详情
    handleEquipmentInfo (row) {
      if (!row || !row.entrustNum) {
        this.$message.warning('缺少委托编号');
        return;
      }
      this.$refs.equipmentConfirmDialog && this.$refs.equipmentConfirmDialog.show(row, 'view');
    },
    // 预览当前记录关联的备忘录文件
    handleMemoDetail (row) {
      if (!row.memoFileUUID) {
        this.$message.warning('文件不存在');
        return;
      }
      this.currentFileUUID = row.memoFileUUID;
      this.previewTitle = '备忘录文件';
      this.previewDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.pdfImgViewer) {
          this.$refs.pdfImgViewer.init();
        }
      });
    },
    // 打开整改项弹窗，查看当前委托单的整改信息
    handleRectificationDetail (row) {
      if (!row || !row.entrustNum) {
        this.$message.warning('委托单编号不能为空');
        return;
      }
      this.$refs.rectificationDialog && this.$refs.rectificationDialog.openDialog(row, { mode: 'view' });
    },
    // 让用户选择预览原始记录或报告文件
    handlePDF (row) {
      if (!row || !row.entrustNum) {
        this.$message.warning('缺少委托编号');
        return;
      }
      this.$confirm('请选择要查看的内容：', '选择打印类型', {
        distinguishCancelAndClose: true,
        confirmButtonText: '原始记录',
        cancelButtonText: '报告',
        type: 'info'
      }).then(() => {
        this.callPreviewAPI(row.entrustNum, 1);
      }).catch(action => {
        if (action === 'cancel') {
          this.callPreviewAPI(row.entrustNum, 0);
        }
      });
    },
    // 调用预览PDF的API
    callPreviewAPI (entrustNum, type) {
      const loading = this.$loading({
        lock: true,
        text: '正在生成PDF，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      previewTestDataPdf({ entrustNums: [entrustNum], type: type }).then(response => {
        loading.close();
        if (response && response.retCode === 'ok' && response.additionalData) {
          this.currentFileUUID = response.additionalData + '.pdf';
          this.previewTitle = type === 0 ? '报告文件' : '原始记录文件';
          this.previewDialogVisible = true;
          this.$nextTick(() => {
            if (this.$refs.pdfImgViewer) {
              this.$refs.pdfImgViewer.init();
            }
          });
          this.$message.success('PDF生成成功');
        } else {
          this.$message.error(response.retMsg || 'PDF生成失败');
        }
      }).catch(error => {
        console.error('查看PDF失败:', error);
        loading.close();
        this.$message.error('查看PDF失败');
      });
    },
    // 关闭文件预览对话框
    closePreviewDialog () {
      this.previewDialogVisible = false;
      this.currentFileUUID = '';
      this.previewTitle = '';
    },
    // 报告下载
    handleDownloadReport (row) {
      if (row.status !== '1') {
        this.$message.warning('只有成功状态的数据才能下载报告');
        return;
      }

      this.$message.info('正在下载报告...');

      // TODO: 调用实际的API
      // downloadReport(row.id).then(response => {
      //   const blob = new Blob([response], {
      //     type: 'application/pdf'
      //   });
      //   const url = window.URL.createObjectURL(blob);
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.download = `检测报告_${row.OIDNO}_${new Date().getTime()}.pdf`;
      //   link.style.display = 'none';
      //   document.body.appendChild(link);
      //   link.click();
      //   document.body.removeChild(link);
      //   window.URL.revokeObjectURL(url);
      //   this.$message.success('下载成功');
      // }).catch(error => {
      //   console.error('下载失败:', error);
      //   this.$message.error('下载失败');
      // });

      // 模拟下载
      setTimeout(() => {
        this.$message.success('下载成功');
      }, 500);
    },
    // 报告打印
    handlePrintReport (row) {
      if (row.status !== '1') {
        this.$message.warning('只有成功状态的数据才能打印报告');
        return;
      }

      this.$message.info('正在准备打印...');

      // TODO: 实现打印功能
      // 可以打开新窗口显示报告，然后调用浏览器打印功能
      // window.open(`/report/print/${row.id}`, '_blank');

      // 模拟打印
      setTimeout(() => {
        this.$message.success('打印准备完成');
      }, 500);
    },
    // 分页大小改变
    handleSizeChange (val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    // 当前页改变
    handleCurrentChange (val) {
      this.queryParams.currPage = val;
      this.getList();
    },
    // 处理表格选择变化
    handleSelectionChange (selection) {
      this.selectedRows = selection;
    },
    // 执行数据上传
    performDataUpload (selectedRows) {
      // 提取选中行的entrustNum数组
      const entrustNums = selectedRows.map(row => row.entrustNum);
      const selectedEntrustNums = new Set(entrustNums);

      console.log('准备上传的数据:', selectedRows);
      console.log('entrustNums数组:', entrustNums);

      // 调用上传接口，传递 entrustNums 数组和 type 参数
      // type 参数传 '0'
      uploadData(entrustNums, '0').then(res => {
        console.log('上传接口返回结果:', res);

        if (res && res.retCode === 'ok') {
          const taskId = res.additionalData;
          console.log('获取到的taskId:', taskId);

          // 将选中行的ispinfoSubmitState设置为'-1'（上传中）
          this.tableData.forEach(item => {
            if (selectedEntrustNums.has(item.entrustNum)) {
              item.ispinfoSubmitState = '-1';
            }
          });

          // 建立SSE连接
          this.createSSEConnection(taskId);
        } else {
          this.$message.error(res.retMsg || '上传失败');
        }
      }).catch(err => {
        console.error('上传失败:', err);
        this.$message.error(err.retMsg || '上传失败，请重试');
      });
    },
    // 创建SSE连接
    createSSEConnection (taskId) {
      const loading = this.$loading({
        lock: true,
        text: '正在上传数据...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      // 关闭已有连接（避免重复连接）
      if (this.eventSource) {
        this.eventSource.close();
      }

      // 获取token
      const token = localStorage.getItem('authorization') || '';

      // 建立SSE连接（GET请求），将token作为URL参数传递
      // 根据后端代码，SSE路径应该是 /api/upload/sse/process
      this.eventSource = new EventSource(`/api/upload/sse/process?taskId=${taskId}&authorization=${token}`);

      // 监听SSE消息（接收后端推送的结果）
      this.eventSource.onmessage = (event) => {
        console.log('SSE消息事件:', event);
        const data = JSON.parse(event.data);
        console.log('SSE消息数据:', data);

        if (data.status === 'finish') {
          // 所有数据处理完成
          loading.close();
          this.$message.success(data.msg || '所有数据上传完成');
          this.eventSource.close();
          // 刷新列表
          //this.getList();
        } else if (data.status === 'error') {
          // 处理错误
          loading.close();
          this.$message.error(data.msg || '上传错误，请重试');
          this.eventSource.close();
        } else {
          // 实时更新单条数据的状态和失败原因
          console.log('开始更新数据,SSE返回的entrustNum:', data.entrustNum);
          console.log('当前表格数据:', this.tableData);

          let found = false;
          this.tableData.forEach((item, index) => {
            console.log('比较:', item.entrustNum, '===', data.entrustNum, '结果:', item.entrustNum === data.entrustNum);
            if (item.entrustNum === data.entrustNum) {
              found = true;
              // 使用$set确保Vue能检测到变化
              this.$set(item, 'ispinfoSubmitState', data.status);
              // 更新失败原因：当状态为失败(2)时，从msg中获取失败原因
              if (data.status === '2') {
                this.$set(item, 'ispinfoSubmitMsg', data.msg || '');
              } else {
                // 成功或处理中时清空失败原因
                this.$set(item, 'ispinfoSubmitMsg', '');
              }
              console.log('✅ 成功更新:', item.entrustNum, '状态:', item.status, '失败原因:', item.ispinfoSubmitMsg);
            }
          });

          if (!found) {
            console.error('❌ 未找到匹配的entrustNum:', data.entrustNum);
          }
        }
      };

      // 监听SSE错误
      this.eventSource.onerror = (error) => {
        loading.close();
        console.error('SSE连接错误：', error);
        this.$message.error('连接错误，请重试');
        this.eventSource.close();
      };

      // 监听SSE连接关闭
      this.eventSource.onclose = () => {
        loading.close();
        console.log('SSE连接已关闭');
      };
    },
    // 新增备注（多选）
    // 批量打开备注新增弹窗，并回填选中记录信息
    AddRemarks () {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning('请先勾选需要新增备注的数据');
        return;
      }
      const entrustNums = this.selectedRows.map(row => row.entrustNum).filter(Boolean);
      const oidnos = this.selectedRows.map(row => row.OIDNO).filter(Boolean);
      this.remarkDialogMode = 'add';
      this.remarkDialogTitle = '新增备注';
      this.remarkForm.operType = '0';
      this.remarkForm.entrustNums = entrustNums;
      this.remarkForm.entrustNumDisplay = entrustNums.join('，');
      this.remarkForm.oidnoDisplay = oidnos.join('，');
      this.remarkForm.ispinfoSubmitRemark = '';
      this.remarkForm.remarkOperator = (this.$store && this.$store.state && this.$store.state.loginUser && this.$store.state.loginUser.userName) || '';
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, '0');
      const dd = String(today.getDate()).padStart(2, '0');
      this.remarkForm.operationDate = `${yyyy}-${mm}-${dd}`;
      this.remarkDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.remarkForm) {
          this.$refs.remarkForm.clearValidate();
        }
      });
    },
    // 修改备注（单条，已停用）
    // ModifyRemarks (row) {
    //   if (!row || !row.entrustNum) {
    //     this.$message.warning('当前行数据不完整，无法修改备注');
    //     return;
    //   }
    //   this.remarkDialogMode = 'edit';
    //   this.remarkDialogTitle = '修改备注';
    //   this.remarkForm.operType = '1';
    //   this.remarkForm.entrustNums = [row.entrustNum];
    //   this.remarkForm.entrustNumDisplay = row.entrustNum || '';
    //   this.remarkForm.oidnoDisplay = row.OIDNO || '';
    //   this.remarkForm.ispinfoSubmitRemark = row.ispinfoSubmitRemark || '';
    //   this.remarkForm.remarkOperator = (this.$store && this.$store.state && this.$store.state.loginUser && this.$store.state.loginUser.userName) || '';
    //   const today = new Date();
    //   const yyyy = today.getFullYear();
    //   const mm = String(today.getMonth() + 1).padStart(2, '0');
    //   const dd = String(today.getDate()).padStart(2, '0');
    //   this.remarkForm.operationDate = `${yyyy}-${mm}-${dd}`;
    //   this.remarkDialogVisible = true;
    //   this.$nextTick(() => {
    //     if (this.$refs.remarkForm) {
    //       this.$refs.remarkForm.clearValidate();
    //     }
    //   });
    // },
    // 确认保存备注
    handleRemarkConfirm () {
      this.$refs.remarkForm.validate((valid) => {
        if (!valid) {
          return;
        }
        const payload = {
          operType: this.remarkForm.operType,
          entrustNums: this.remarkForm.entrustNums,
          ispinfoSubmitRemark: this.remarkForm.ispinfoSubmitRemark,
          operationDate: this.remarkForm.operationDate
        };
        submitTestDataRemark(payload).then(res => {
          if (res && res.retCode === 'ok') {
            this.$message.success('备注保存成功');
            const entrustSet = new Set(this.remarkForm.entrustNums);
            this.tableData.forEach(item => {
              if (entrustSet.has(item.entrustNum)) {
                this.$set(item, 'ispinfoSubmitRemark', this.remarkForm.ispinfoSubmitRemark);
              }
            });
            this.closeRemarkDialog();
          } else {
            this.$message.error((res && res.retMsg) || '备注保存失败');
          }
        }).catch(error => {
          console.error('备注保存失败:', error);
          this.$message.error('备注保存失败，请重试');
        });
      });
    },
    // 关闭备注对话框
    closeRemarkDialog () {
      this.remarkDialogVisible = false;
      if (this.$refs.remarkForm) {
        this.$refs.remarkForm.resetFields();
      }
      this.remarkForm.entrustNums = [];
      this.remarkForm.entrustNumDisplay = '';
      this.remarkForm.oidnoDisplay = '';
      this.remarkForm.operType = '0';
      this.remarkForm.operationDate = '';
    }
  },
  // 组件销毁前关闭SSE连接，避免页面离开后继续监听
  beforeDestroy () {
    // 组件销毁时关闭SSE连接
    if (this.eventSource) {
      this.eventSource.close();
    }
  }
};
</script>

<style scoped>
.app-container {
  padding: 20px;
}

/* 状态文本颜色样式 */
.status-text {
  font-weight: 500;
}

.status--1 {
  color: orange;
}

.status-0 {
  color: green;
}

.status-1 {
  color: gray;
}

.status-2 {
  color: red;
}

.upload-demo {
  text-align: center;
}

.el-upload__tip {
  color: #999;
  font-size: 12px;
  margin-top: 10px;
}

.video-container {
  text-align: center;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-video {
  text-align: center;
}

.detail-section {
  margin-bottom: 20px;
}

.detail-section:last-child {
  margin-bottom: 0;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 15px;
  padding-left: 10px;
  border-left: 4px solid #409eff;
}

.file-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  padding: 10px;
}

.file-buttons .el-button {
  flex: 0 0 calc(50% - 8px);
}

.info-content {
  padding: 10px 20px;
  background-color: #f9f9f9;
  border-radius: 4px;
}

.info-row {
  display: flex;
  align-items: center;
  padding: 8px 0;
  line-height: 1.8;
  border-bottom: 1px solid #ebeef5;
}

.info-row:last-child {
  border-bottom: none;
}

.info-label {
  flex-shrink: 0;
  min-width: 140px;
  color: #606266;
  font-weight: 500;
  font-size: 14px;
}

.info-value {
  flex: 1;
  color: #303133;
  font-size: 14px;
  word-break: break-all;
}
::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>
